import { render, staticRenderFns } from "./IsOther.vue?vue&type=template&id=747852a1&scoped=true&"
import script from "./IsOther.vue?vue&type=script&lang=js&"
export * from "./IsOther.vue?vue&type=script&lang=js&"
import style0 from "./IsOther.vue?vue&type=style&index=0&id=747852a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747852a1",
  null
  
)

export default component.exports